import { render, staticRenderFns } from "./SubmitTaskList.vue?vue&type=template&id=45eaaea9"
import script from "./SubmitTaskList.vue?vue&type=script&lang=js"
export * from "./SubmitTaskList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JSH_ERP\\JSH_ERP\\mgerpweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45eaaea9')) {
      api.createRecord('45eaaea9', component.options)
    } else {
      api.reload('45eaaea9', component.options)
    }
    module.hot.accept("./SubmitTaskList.vue?vue&type=template&id=45eaaea9", function () {
      api.rerender('45eaaea9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/plugin/workflow/SubmitTaskList.vue"
export default component.exports